export const formatoDinero = (valor) => Number(valor || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN" });

export const TIPOS_PRECIO = [
    { value: "unitario", label: "Por unidad (usuario / empresa)" },
    { value: "fijo", label: "Precio fijo" },
    { value: "niveles", label: "Por paquetes (niveles)" },
];

export const textoPrecioConcepto = (concepto) => {
    if (!concepto) return "";
    if (concepto.tipoPrecio === "niveles") {
        return (concepto.niveles || [])
            .map((n) => `${n.nombre}: ${formatoDinero(n.precio)}${n.limite ? ` (hasta ${n.limite})` : ""}`)
            .join(" · ");
    }
    return formatoDinero(concepto.precio) + (concepto.tipoPrecio === "unitario" ? " c/u" : "");
};

export const postCobro = (axios, ruta, body, headersToken) => axios.post("cobroBiwo/" + ruta, body, { headers: headersToken }).then((res) => res.data);

export const DIAS_CORTE_ANTES_BLOQUEO = 5;

export const cicloCobro = (moment, { periodicidad, diasAntesEmision }, fechaBloqueo) => {
    if (!fechaBloqueo || !moment(fechaBloqueo).isValid()) return null;
    const meses = periodicidad === "anual" ? 12 : 1;
    const inicio = moment(fechaBloqueo).startOf("day");
    const corte = inicio.clone().subtract(DIAS_CORTE_ANTES_BLOQUEO, "days");
    const emision = corte.clone().subtract(Number.isInteger(diasAntesEmision) ? diasAntesEmision : 10, "days");
    const formato = (m) => m.format("DD/MM/YYYY");
    return {
        bloqueo: formato(inicio),
        corte: formato(corte),
        emision: formato(emision),
        periodo: `${formato(inicio)} – ${formato(inicio.clone().add(meses, "months").subtract(1, "day"))}`,
        siguienteBloqueo: formato(moment(fechaBloqueo).add(meses, "months")),
    };
};

export const nombreDocumento = (tipoDocumento) => (tipoDocumento === "factura" ? "factura" : "remisión");
